<template lang="pug">
    div
        .title Monto:
        v-text-field.title#transbank-pay-input(
            :mask="mixCurrencyMask(transbankPayment, 12)"
            placeholder="Ingrese monto pagado por transbank"
            prefix="$"
            v-model="transbankPayment"
            :rules='[rules.required, rules.validPayment, rules.notZero]'
            @input="setTransbankPayment()"
            @keyup.enter="focusNext()"
            )
        v-switch( label='Ticket de transportista' v-model='carrier' )

        // voucher
        template(v-if="showVoucher")

            // voucher divider
            v-divider

            // carrier identifier
            template( v-if='carrier' )

                // carrier identifier
                h4.title Identificador de transportista
                v-text-field.title.elevation-2(
                    hide-details
                    label='ola'
                    mask='A##'
                    placeholder='Ingrese el identificador del transportista'
                    single-line
                    solo
                    flat
                    v-model='identifier'
                    )

            // voucher number
            h4.title N° de voucher
            v-text-field.title#transbank-voucher-num-input(solo
                placeholder="Ingrese n° de voucher"
                v-model="voucher"
                :rules='[rules.required]' 
                validate-on-blur
                @keyup='refreshVoucher'
                @keyup.enter="handleEnter($event)"
                tabindex="-1"
                )
</template>

<script>
// Mixins:
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import JSUtils from '@/mixins/CurrencyUtils'
/* vuex */
import { mapState, mapGetters, mapActions } from 'vuex'
/* services */
import { getTransbankNumber } from '@/services/API/Integration/'
export default {
    name: 'transbank-payment',
    props: {},
    data: function() {
        return {
            carrier: false,
            identifier: '',
            voucher: '',
            transbankPayment: '',
        }
    },
    computed: {
        showVoucher() {
            return !this.isTransbankIntegrated || this.carrier
        },
        integrationCountersAreEnabled() {
            return JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS)
        },
        /**
         *
         */
        ...mapState('CustomerPaymentModule', {
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),
        /**
         *
         */
        ...mapGetters('CustomerPaymentModule', {
            totalToPay: 'totalToPay',
        }),
        ...mapState('SessionModule', ['isTransbankIntegrated']),
        /**
         *
         */
        allTransbankDataSet: function() {
            // let isSet =
            //     this.transbankPayment &&
            //     parseInt(this.transbankPayment) >= 50 &&
            //     parseInt(this.transbankPayment) <= this.totalToPay
            // if (this.voucherShow)
            //     isSet =
            //         isSet && this.voucher && ('' + this.voucher).length === 6
            // return isSet
            return this.isTransbankIntegrated
                ? this.transbankPayment &&
                      parseInt(this.transbankPayment) >= 50 &&
                      parseInt(this.transbankPayment) <= this.totalToPay
                : this.voucher.length === 6 &&
                      this.transbankPayment &&
                      parseInt(this.transbankPayment) >= 50 &&
                      parseInt(this.transbankPayment) <= this.totalToPay
        },
    },
    methods: {
        ...mapActions('CustomerPaymentModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),
        setTransbankPayment() {
            if (parseInt(this.transbankPayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.transbankPayment)
            }
        },
        async getVaucherNumber() {
            if (
                this.isTransbankIntegrated ||
                !this.integrationCountersAreEnabled
            )
                return
            let response = await getTransbankNumber()
            this.setVoucherNumber(response)
        },
        setVoucherNumber(number) {
            if (this.isTransbankIntegrated) return
            this.voucher = number.toString().padStart(6, '0')
        },
        focusNext() {
            document.getElementById('transbank-voucher-num-input').focus()
        },
        handleEnter(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('confirm')
        },

        /**
         * 
         */
        refreshVoucher() {
            let paymentAmount       = this.transbankPayment 
            let paymentVoucher      = this.carrier ? `${ this.identifier }${ this.voucher }` : this.voucher
            let paymentVoucherDetail= this.showVoucher ? paymentVoucher : null
            this.setPayment(paymentAmount)
            this.setPaymentDetail({ voucher: paymentVoucherDetail })
        }
    },
    watch: {
        /**
         * @description updates payment details in store depending of they are fully set in form or not.
         */
        allTransbankDataSet: function(newVal) {
            if (newVal) {

                let paymentAmount       = this.transbankPayment 
                let paymentVoucher      = this.carrier ? `${ this.identifier }${ this.voucher }` : this.voucher
                let paymentVoucherDetail= this.showVoucher ? paymentVoucher : null

                this.setPayment(paymentAmount)
                this.setPaymentDetail({ voucher: paymentVoucherDetail })

                // console.log(this.carrier, 'carrier')
                // console.log(this.voucher, 'voucher')
                // console.log({ paymentVoucherDetail, paymentVoucher })
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },

        /**
         * @description If payment method changes (example: from debit to credit),
         * voucher data and payment data is reseted to their original values.
         */
        paymentMethod: function() {
            if (!this.isTransbankIntegrated || this.carrier) this.voucher = ''
            this.transbankPayment = this.totalToPay.toString()
        },

        /**
         * 
         */
        voucher() {
            this.refreshVoucher()
        },
    },
    components: {},
    mixins: [PaymentRules, CurrencyUtils, JSUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        // this.voucher = ''
        this.transbankPayment = this.totalToPay.toString()
        if (!this.isTransbankIntegrated) this.getVaucherNumber()
        setTimeout(() => {
            document.getElementById('transbank-pay-input').focus()
            console.log('fdsa')
        }, 200)
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
